import React, { useState, useEffect, useContext } from 'react';
import * as fkn from "../lib/fkn";
import * as net from "../lib/net";
import SDOContext from '../sdo.js'
import ddo from "../ddo";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Cas_Home extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    //context.posrend = this;
      this.state.units = Object.values(ddo.cfg.units);
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }

  trans() {
      var self = this;
    var datum = "20200328";
    var prm = {};
    prm.req = "pos.pos_cas.trs_dt";
    prm.fdat = datum;
    prm.tdat = datum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({tra: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
    }

  render() {
    return (
    <div className="web-app">

    <div className="web-row">
        <h3>KASINO SYSTEM</h3>
    </div>

    <div className="divider"></div>

    <div className="web-row">
        <h3>ÖVERSIKT KOMMER INOM KORT</h3>
    </div>

    </div>
  );
}
}
export default Cas_Home;
